import { reactive_label, reactive_button } from 'ui_commons'
import { Image, UrlParamsToObject, in_iframe, get_prop } from "utils"
import Server, { server_login } from 'network/network_api'
import { SERVER_IDENTITY_TYPE, canGo, TYPE } from 'network/server_tool'
import { request, OPERATION_ID } from 'network/request'
import SETTINGS from 'settings'
import { main } from 'boot'
import { REQUEST_TYPE } from 'network/net'
import { Animation } from 'animation'
import Space from 'frp/space'
import { connect, glue } from 'init'
import { literal_price } from "ui_commons"
import abstract_game, { GAME_SETTINGS } from 'games/abstract'
import gameConfig from 'cfg/game-config.js'
import versionInfo from 'src/version'

import SceneTerms from './terms_scene';
import SceneEvents from './events_scene';
import SceneLobby from './lobby_scene';
import SceneHelp from './help_scene';
import messageScene from './message';

import RFID_Connector from './rfid_daemon_connector';

import {KEYS, createLobbyUI} from './lobby_ui';

import game_41 from 'games/game_41'
import game_42 from 'games/game_42'
import game_45 from 'games/game_45'
import game_55 from 'games/game_55'
import game_56 from 'games/game_56'
import game_40 from 'games/game_40'

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

console.log( 'href:', window.location.href )
const url_params = UrlParamsToObject()
console.log( 'params:', url_params )

//клавиши F1-10 и esc, отключаем стандартное поведение в браузере
window.onkeydown = e => {
    if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) return false;
    return true;
};
window.onkeyup = e => {
    if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) return false;
    return true;
};

SETTINGS.load_sounds = [];
SETTINGS.load_graphics = [
    'res/common/load_process_indicator.json',
    'res/common/no_connection.json',
    'res/common/connection_failed.png',
    
    'res/main_screen.png',
    'res/term_pages/page_0.png',
    'res/term_pages/page_1.png',
    'res/term_pages/page_2.png',
    'res/term_pages/page_3.png',
    'res/term_pages/page_4.png',
    'res/terms_panel_ui.png',
    'res/events_screen.png',
    'res/sport_event.png',
    'res/meteo_event.png',
    'res/choice_event_panel_ui.png',
    'res/lobby_up_panel_ui.png',
    'res/lobby_down_panel_ui.png',
    'res/fonts/terminal_white_font.xml',
    'res/fonts/points_font.xml',
    'res/fonts/result_font.xml',

    'res/info_screen.png',
    'res/info_up_panel_ui.png',
    'res/info_down_panel_ui.png',
    'res/fonts/terminal_red_font.xml',

    'res/game_icons/games_choice_frame.png',
    'res/game_icons/icon_game_40.png',
    'res/game_icons/icon_game_41.png',
    'res/game_icons/icon_game_42.png',
    'res/game_icons/icon_game_45.png',
    'res/game_icons/icon_game_55.png',
    'res/game_icons/icon_game_56.png',

    'res/help_info/info_event_page_000.png',
    'res/help_info/info_event_page_001.png',
    'res/help_info/info_event_page_002.png',
    'res/help_info/info_event_page_003.png',
    'res/help_info/info_event_page_004.png',
    'res/help_info/info_event_page_005.png',
    'res/help_info/info_event_page_006.png',
    'res/help_info/info_event_page_007.png',
    'res/help_info/info_event_page_008.png',
    'res/help_info/info_event_page_009.png',
    'res/help_info/info_event_page_010.png',
    'res/help_info/info_event_page_011.png',
    'res/help_info/info_event_page_012.png',
    'res/help_info/info_event_page_013.png',
    'res/help_info/info_event_page_014.png',
    'res/help_info/info_event_page_015.png',
    'res/help_info/info_event_page_016.png',
    'res/help_info/info_event_page_017.png',
    'res/help_info/tab_events_off.png',
    'res/help_info/tab_events_on.png',
    'res/help_info/tab_rules_off.png',
    'res/help_info/tab_rules_on.png',

    'res/lobby_interface.json',
    'res/loading_wheel.json',

    'res/message_window/card_back.png',
    'res/message_window/disable_game.png',
    'res/message_window/problem_card_reader.png',
    'res/message_window/result_message.png',
    'res/fonts/window_font.xml',

];
SETTINGS.no_default_screen_handler = true;
SETTINGS.preserve_resource_format_for_all = true;
SETTINGS.no_ears = true;

SETTINGS.custom_init = lobby;
SETTINGS.no_server = true
SETTINGS.no_load_scene = true;
//SETTINGS.no_popup_scene = true
SETTINGS.no_fullscreen = true;

const STATES = {
    SHOW_TERMS: 0,
    CHOICE_EVENT: 1,
    CHOICE_GAME: 2,
    SHOW_INFO: 3,
    GAME_OPEN: 4
};

let CURRENT_STATE = STATES.SHOW_TERMS;

const RFID = url_params[ 'auth' ] == 'phoenix_rfid'
const DEMO_LOGIN = url_params[ 'demo' ] == 1
const DEV_MODE = url_params[ 'dev_mode' ] == 1

SETTINGS.serverOptions = {
    gameless : true,
    poll_settings : false,
    inherit_session : DEMO_LOGIN,
    allow_multiple_requests : true,
}

//--------------------------------------

let server
let rfid_connector


function login(
    space,
    server,
)
{
    space.s( 'login' ).on( credentials => {
        if ( credentials && credentials.terminal_id ) {
            credentials.identity_type_id = SERVER_IDENTITY_TYPE.SPORTBET
            delete SETTINGS.url_params.demo
        }
        else {
            SETTINGS.url_params[ 'demo' ] = 1
        }
        
        server.login(
            //release:
            window.location.href.indexOf( 'wbg.ngmcasino.com' ) >= 0
            ?
            'https://wbg.ngmcasino.com/wbg_server/index.php?r=game'
            :
            //develop:
            'https://wbgdev.ngmcasino.com/wbg_server/index.php?r=game'
            ,
            undefined,
            undefined,
            whatever => space.s( 'on_login' ).next( whatever ),
            e => space.s( 'error' ).next( ({ type : 'fail', e }) ),
            e => space.s( 'error' ).next( ({ type : 'fatal', e }) ),
            SETTINGS.serverOptions,
            undefined,
            credentials,
        )
    } )
    
    //close session when no card:
    space.s( 'logout' )
        .map( () => ({
            type : REQUEST_TYPE.CUSTOM,
            f : () => {
                request(
                    server,
                    OPERATION_ID.SESSION_CLOSE,
                )
            },
        }) )
        .to( space.s( 'request' ) )
}

console.log( 'USER_ENV:', USER_ENV )
//TODO: можно переделать на чтение чего-тов из url_params:
function debug_user() {
    switch ( USER_ENV ) {
        case 'slaus':
            return {
                username : 'iru3',
                password : 'iru3',
            }
    }
    return {
        username : 'test',
        password : 'test',
    }
}

main({
    //открыли страницу с игрой:
    on_space : space => {
        server = new Server(
            gameConfig.gameNetworkId,
            versionInfo.name,
            undefined,
            undefined,
            space,
        );
        server.override_app_id = 117
        space.s( 'server' ).next( server )

        login(
            space,
            server,
        );

        space.s( 'is_demo').next(true);
        space.s( 'card:attach' ).map(() => true).to( space.s( 'card:present' ) );
        space.s( 'card:remove' ).map(() => false).to( space.s( 'card:present' ) );
        space.s( 'on_login' )
            .map( () => false )
            .to( space.s( 'is_demo' ) );

        space.s( 'on_login' ).on(e => console.log('ON LOGIN ', e))

        space.s( 'card:attach' )
            .filter( ({ isChanged }) => ! DEMO_LOGIN && isChanged )
            .map( card => {
                card = _.cloneDeep( card )
                delete card.isChanged
                card.create = true
                return card
            } )
            .to(space.s( 'login' ));

        // space.s('card:absend_rfid')
        //     .distinctUntilChanged()
        //     .filter( absend => absend && ! DEMO_LOGIN && DEV_MODE )
        //     .map( debug_user )
        //     .do( () => {
        //         server.gameId = gameConfig.gameNetworkId
        //     } )
        //     .to(space.s( 'login' ));
        
        rfid_connector = new RFID_Connector( space )
        if (!DEMO_LOGIN && !DEV_MODE) {
            rfid_connector.tryRfidRequest(true)
        }
        
        space.s( 'login' ).on(credential => console.log('LOGIN CREDENTIAL', credential));
        
        if ( DEMO_LOGIN ) space.s( 'login' ).next()

        if (DEV_MODE) {
            space.s( 'login' ).next(debug_user());
        }

        space.s( 'is_demo').on(is => console.log('IS DEMO', is))
    },
})

//TODO: здесь добавлять игры:
const GAMES = [
    game_41,
    game_42,
    game_45,
    game_55,
    game_56,
    game_40
];
const games = GAMES.map( g => g( _.cloneDeep( GAME_SETTINGS ) ) )
//differentiate loaded bundles from any other bundles:
for ( const g of games ) g.game = true
//unify resources so that PIXI stops complaining:
for ( let gi = 0; gi < games.length; ++ gi ) {
    const g = games[ gi ]
    for ( const gr of g.graphics ) {
        for ( let ai = gi + 1; ai < games.length; ++ ai ) {
            const a = games[ ai ]
            for ( const ari in a.graphics ) {
                const ar = a.graphics[ ari ]
                if ( g.graphics.includes( ar ) ) {
                    a.graphics.splice( ari, 1 )
                    break
                }
            }
        }
    }
}

function SCALE( w, h ) {
    return Math.min( w / 1920, h / 1080 )
}

export const FAKE_TERMINAL_ID = '000000';

export function formatTerminalId(id) {
    if (!id) {
        return FAKE_TERMINAL_ID;
    }

    let t_id = id.toString();
    if (t_id[0] == '-') {
        t_id = t_id.substring(1);
    }
    if (t_id.length > 6) {
        t_id = t_id.substring(0, 6);
    }

    return t_id;
}

function lobby({
    space,
    container,
    errorDriver,
    popupScene,
})
{
    popupScene.visible = false;

    //сцена правил и пользовательского соглашения
    const sceneUsersTerms = new SceneTerms();
    container.addChild(sceneUsersTerms);
    //----------

    // Сцена выбора типа событий
    const sceneEventChoice = new SceneEvents(space);
    container.addChild(sceneEventChoice);
    //----------

    // основная сцена с выбором игр
    const sceneLobbyGames = new SceneLobby(space, games.map(g => g.name));
    container.addChild(sceneLobbyGames);
    //---------

    //контейнер для игр
    const gameContainer = new PIXI.Container();
    container.addChild(gameContainer);

    let redFrame = new Sprite(TextureCache['res/game_icons/games_choice_frame.png']);
    //размеры подобраны с учетом размера контейнера игры в 1576x885
    redFrame.width = 1576;
    redFrame.height = 885;
    redFrame.visible = false;
    gameContainer.addChild(redFrame);

    //информация
    const sceneHelpLobby = new SceneHelp();
    container.addChild(sceneHelpLobby);

    //сообщения
    const sceneMessage = new messageScene(space);
    container.addChild(sceneMessage);

    let terminal_id = (space.s( 'card:attach' ).value) ? space.s( 'card:attach' ).value.terminal_id : FAKE_TERMINAL_ID;
    sceneUsersTerms.setTerminalId(terminal_id);
    sceneEventChoice.setTerminalId(terminal_id);
    sceneHelpLobby.setTerminalId(terminal_id);

    //------------------

    //- предзагрузка ресурсов всех игр
    let loaded = false;
    let countLoadGame = 0;

    sceneLobbyGames.showLoaders();

    space.s('load:load').next(games);

    space.s( 'load:complete' )
        .filter( ({ bundle }) => bundle && bundle.game )
        .with(
            space.s('lobby_ui:isTerms'),
            space.s('lobby_ui:isEventsChoice'),
            space.s('lobby_ui:isGamesRun'),
            (_, terms, events, game) => !(terms || events || game)
            )
        .do(() => {
            countLoadGame++;

            if (countLoadGame === games.length) {
                loaded = true;
                sceneLobbyGames.loadComplete();
            }
        })
        .filter(enterLobby => enterLobby)
        .to(space.s('lobby_ui:isLobbyGames'));


    //--------------------

    createLobbyUI(space, {
        terms: sceneUsersTerms,
        info: sceneHelpLobby,
        events: sceneEventChoice,
        lobby: sceneLobbyGames
    });


    space.s( 'resize' ).on( ({ w, h }) => {
        container.scale.x = w / 1920;
        container.scale.y = h / 1080;
    } );

    CURRENT_STATE = STATES.SHOW_TERMS;
    sceneLobbyGames.visible = false;
    sceneEventChoice.visible = false;
    sceneHelpLobby.visible = false;
    sceneMessage.hide();

    let real_teminal_id = new PIXI.Text( '', { fontSize : 24, fill : 0xff0000, align : 'center' } );
    real_teminal_id.position.set(960, 1060);
    real_teminal_id.anchor.x = 0.5;
    real_teminal_id.visible = false;
    container.addChild(real_teminal_id);

    //обработка кнопок и клавиш
    space.s( 'keyboard' )
        .filter( k => k === KEYS.START )
        .on( () => {
            switch(CURRENT_STATE) {
                case STATES.CHOICE_EVENT:
                    if (sceneEventChoice.canChoiceEvent()) {
                        space.s('eventSelected').next();
                    }
                    break;
            }
        } );
    
    space.s('eventSelected').on(() => {
        CURRENT_STATE = STATES.CHOICE_GAME;
        sceneEventChoice.visible = false;
        sceneLobbyGames.visible = true;

        space.s('lobby_ui:isEventsChoice').next(false);

        if (loaded) {
            sceneLobbyGames.showLoaders();
            setTimeout(() => {
               space.s('lobby_ui:isLobbyGames').next(true);
               sceneLobbyGames.loadComplete();
            }, 1000);
        }

    });

    space.s( "lobby_ui:termsAgree" ).on(() => {
        CURRENT_STATE = STATES.CHOICE_EVENT;
        sceneEventChoice.visible = true;
        sceneUsersTerms.visible = false;
    });

    space.s('lobby_ui:choiceGame')
        .withLatestFrom(space.s('lobby_ui:isGamesRun'), (choice, isRun) => isRun)
        .on(isRun => {
            if (isRun) {
                // gameContainer.scale.set(1.0, 1.0);
                // gameContainer.position.set(172, 87);
                // sceneLobbyGames.hideGameMenu();
            }
            else {
                sceneLobbyGames.openGame();
            }
        });

    space.s( 'keyboard' )
        .filter(k => [KEYS.KEY_1, KEYS.KEY_9].includes(k))
        .on(k => {
            if (CURRENT_STATE === STATES.CHOICE_EVENT) {
                sceneEventChoice.swapEvents(k === KEYS.KEY_9);
            }
        });

    space.s( 'keyboard' )
        .filter(k => k === 66 && !real_teminal_id.visible)
        .on(() => {
           real_teminal_id.visible = true;
           setTimeout(() => {
               real_teminal_id.visible = false;
           }, 5000)
        });

    space.s('lobby_ui:prevTermPage').on(() => {
        sceneUsersTerms.prevPage();
        if (sceneUsersTerms.isFirstPage()) {
            space.s('lobby_ui:button_prevTermPage_enabled').next(false);
        }
        if (!sceneUsersTerms.isLastPage()) {
            space.s('lobby_ui:button_nextTermPage_enabled').next(true);
        }
    });
    space.s('lobby_ui:nextTermPage').on(() => {
        sceneUsersTerms.nextPage();
        if (!sceneUsersTerms.isFirstPage()) {
            space.s('lobby_ui:button_prevTermPage_enabled').next(true);
        }
        if (sceneUsersTerms.isLastPage()) {
            space.s('lobby_ui:button_nextTermPage_enabled').next(false);
        }
    });

    space.s('lobby_ui:prevGame').on(() => {
        sceneLobbyGames.setPrevGameFocus();
    });
    space.s('lobby_ui:nextGame').on(() => {
        sceneLobbyGames.setNextGameFocus();
    });

    space.s('lobby_ui:infoPrev').on(() => {
        sceneHelpLobby.prevPage();
        if (sceneHelpLobby.isFirstPage()) {
            space.s('lobby_ui:button_infoBack_enabled').next(false);
        }
        if (!sceneHelpLobby.isLastPage()) {
            space.s('lobby_ui:button_infoForward_enabled').next(true);
        }
    });
    space.s('lobby_ui:infoNext').on(() => {
        sceneHelpLobby.nextPage();
        if (!sceneHelpLobby.isFirstPage()) {
            space.s('lobby_ui:button_infoBack_enabled').next(true);
        }
        if (sceneHelpLobby.isLastPage()) {
            space.s('lobby_ui:button_infoForward_enabled').next(false);
        }
    });


    let prevState = CURRENT_STATE;
    space.s('lobby_ui:openInfo').on(() => {
        prevState = CURRENT_STATE;
        CURRENT_STATE = STATES.SHOW_INFO;
        sceneHelpLobby.open();
    });
    space.s('lobby_ui:openInfo').delay(0).map(() => false).to(space.s('lobby_ui:button_infoBack_enabled'));

    space.s('lobby_ui:infoExit').on(() => {
        CURRENT_STATE = prevState;
        sceneHelpLobby.visible = false;
    });

    space.s('isFullScreenGame', false);

    space.s('lobby_ui:changeGame')
        .withLatestFrom(space.s('isFullScreenGame'), (b, isFS) => isFS)
        .on((isFS) => {
            if (isFS) {
                sceneLobbyGames.closeGame();
                CURRENT_STATE = STATES.CHOICE_GAME;
                space.s('kill_game').next();

                space.s('isFullScreenGame').next(false);
            }
            else {
                gameContainer.scale.set(1.0, 1.0);
                gameContainer.position.set(172, 87);
                redFrame.visible = false;
                sceneLobbyGames.hideGameMenu();

                space.s('isFullScreenGame').next(true);
            }
        });

    space.s('kill_game').on(() => {
        redFrame.visible = false;
    });

    space.s('kill_game').map(() => false).to(space.s('lobby_ui:isGamesRun'));
    //обработка кнопок и клавиш КОНЕЦ

    network( space, errorDriver )

    space.s('balance')
        .on((balance) => {
            let gameable_money = balance.money;
            let minor_unit = balance.minor_unit;

            let text = literal_price(gameable_money, minor_unit, '.');
            sceneLobbyGames.setBalance(text);
            sceneEventChoice.setBalance(text);
        });
    
    run_game( space, gameContainer/*container*/, server );

    space.s( 'run_game' )
        .filter(game_id => game_id < games.length)
        .withLatestFrom(space.s('isFullScreenGame'), (game, isFS) => isFS)
        .do((isFS) => {
            CURRENT_STATE = STATES.GAME_OPEN;
            sceneLobbyGames.closeGame();
            sceneLobbyGames.onGameOpen();

            if (isFS) {
                gameContainer.scale.set(1.0, 1.0);
                gameContainer.position.set(172, 87);
                redFrame.visible = false;
                sceneLobbyGames.hideGameMenu();

                space.s('isFullScreenGame').next(true);
            }
            else {
                gameContainer.scale.set(0.7, 0.7);
                gameContainer.position.set(500, 200);

                space.s('isFullScreenGame').next(false);
            }
            
         })
        .map(() => true)
        .to(space.s('lobby_ui:isGamesRun'));

    space.s('game_can_show').on(() => {
        if (gameContainer.scale.x < 1.0) {
            redFrame.visible = true;
        }
    });
    space.s('error_driver:isError').on(() => {redFrame.visible = false});

    space.s( 'card:attach' )
        .filter( ({ isChanged }) => ! DEMO_LOGIN && isChanged )
        .on(() => {
            space.s('kill_game').next();
            space.s('lobby_ui:isTerms').next(true);
            CURRENT_STATE = STATES.SHOW_TERMS;
            sceneLobbyGames.visible = false;
            sceneEventChoice.visible = false;
            sceneHelpLobby.visible = false;
            sceneUsersTerms.visible = true;
        });

    const goDemo = () => {
        space.s('is_demo').next(true);
        space.s('lobby_ui:isTerms').next(true);

        space.s( 'logout' ).next();

        CURRENT_STATE = STATES.SHOW_TERMS;
        sceneLobbyGames.visible = false;
        sceneEventChoice.visible = false;
        sceneHelpLobby.visible = false;
        sceneUsersTerms.visible = true;
    }

    space.s( 'card:remove' )
        .withLatestFrom(space.s('card_need_remove'), (_, need) => need)
        .filter(need => need)
        .on(() => {
            rfid_connector.resetCard();
            space.s('card_need_remove').next(false);
            goDemo();
        });

    space.s('lobby_ui:stopPari').to(space.s('kill_game'));

    //показ сообщений-----------------

    space.s( 'card:remove' )
        .withLatestFrom(space.s('card_need_remove'), (_, need) => need)
        .filter(need => !need)
        .on(() => {
            sceneMessage.showCardBackMessage(() => {

                rfid_connector.resetCard();

                space.s('kill_game').next();

                goDemo();
            })
        });

    // space.s( 'card:attach' ).on(() => {
    //     sceneMessage.hide();
    // });

    space.s('card:absend_rfid')
        .distinctUntilChanged()
        .filter( absend => absend && ! DEMO_LOGIN && !DEV_MODE )
        .do(() => {
            sceneMessage.showRFIDProblem();
        })
        .to(space.s('is_demo'));

    // space.s('card:absend_rfid')
    //     .distinctUntilChanged()
    //     .filter(absend => !absend)
    //     .on(() => {
    //         sceneMessage.hide();
    //     });

    if (space.s('card:absend_rfid').value && ! DEMO_LOGIN && !DEV_MODE) {
        sceneMessage.showRFIDProblem();
    }

    //---------------------------------------------

    space.s('card:terminal_id').on(id => {
        let fake_id = formatTerminalId(id);
        sceneUsersTerms.setTerminalId(fake_id);
        sceneEventChoice.setTerminalId(fake_id);
        sceneHelpLobby.setTerminalId(fake_id);

        real_teminal_id.text = 'Терминал №' + id;
    });
    
    //spin delay to replicate original game:
    const ira = space.s( 'imperative_request' ).alter()
    const should_be_delayed = ({ r, n }) => ( r.type == REQUEST_TYPE.SPIN ) || (r.type === REQUEST_TYPE.CHOOSE_AT_RISK) || ( canGo( TYPE.FREESPIN, n.state ) && r.type == REQUEST_TYPE.PROCEED )
    space.s( 'imperative_request' )
        .with( space.s( 'net' ), ( r, n ) => ({ r, n }) )
        .filter( p => p.n && should_be_delayed( p ) )
        .map( ({ r }) => r )
        .delay( 800 )
        .to( ira )
    space.s( 'imperative_request' )
        .with( space.s( 'net' ), ( r, n ) => ({ r, n }) )
        .filter( p => ! p.n || ! should_be_delayed( p ) )
        .map( ({ r }) => r )
        .to( ira )

    
    //в самом конце чтобы любые зависимые от размера экрана стримы (элементы) шевельнулись:
    space.apply();
    space.s('lobby_ui:isTerms').next(true);
    setTimeout(() => {space.s('lobby_ui:button_prevTermPage_enabled').next(false)}, 0);
    space.s( 'resize' ).next( space.s( 'resize' ).value );

    space.s('card:terminal_id').next(space.s('card:terminal_id').value);
}

function network( space, errorDriver )
{
    space.s( 'balance_poll' )
        .map( () => false )
        .to( errorDriver.$isError )

    space.s( 'balance_poll' )
        .filter( b => b )
        .map( b => b.gameable )
        .name( space, 'balance:credits' );
    if ( space.s( 'balance_poll' ).value ) space.s( 'balance_poll' ).next( space.s( 'balance_poll' ).value )

    space.s( 'balance_poll' )
        .map(balance => {
            return {
                money: balance.gameable_money,
                minor_unit: balance.currency.minor_unit
            }
        })
        .to(space.s('balance'))
}


/** Запуск игр по какой-то логике (пока что клавиатурой). Прежде чем запустить игру, скачиваются ресурсы этой игры.
@param container где должна отображаться игра. При каждом запуске игры создаётся новый контейнер и помещается в container. Контейнер текущей игры уничтожается при например выходе из игры или при какой-то ошибке.
*/
function run_game( space, container, server )
{
    const do_run = (game) => {
        dispose()

        app.space = new Space( game.name )

        app.container = new PIXI.Container
        container.addChildAt( app.container, 0 )

        space.s( 'sportbet:server' ).next( undefined )

        server.gameId = game.id
        server.name = game.name
        server.gameless = false

        space.s( 'request' ).next( { type : REQUEST_TYPE.INIT, options : { preset : true } } )

        loading = true
    };

    space.s( 'run_game' )
        .filter( game => (game !== undefined) && (game !== null) && (game < games.length) )
        .do( game_index => space.s( 'running_game' ).next( game_index ) )
        .map( game => games[game] )
        .do( b => do_run( b ) )
        .name( space, 'sportbet:load_game' );

    space.s( 'kill_game' ).on( dispose )
    space.s( 'kill_game' )
        .map( () => undefined )
        .to( space.s( 'running_game' ) )
    
    let loading
    //just a flag that server is ready:
    space.s( 'net' )
        .map( () => true )
        .to( space.s( 'sportbet:server' ) )
    
    const app = {}
    function dispose() {
        //continue communicating as lobby:
        server.gameId = gameConfig.gameNetworkId
        server.name = versionInfo.name
        server.gameless = true

        if ( app.space ) app.space.clear()
        delete app.space
        if ( app.container ) app.container.destroy( { children : true } )
        delete app.container
    }
    
    //run game if already loaded:
    space.s( 'sportbet:load_game' )
        .any( space.s( 'sportbet:server' ), ( b, s ) => ({ b, s }) )
        //TODO: maybe ignore loaded bundle in case of preliminary loading:
        .filter( ({ b, s }) => b && b.game && b.loaded && s && loading )
        .do( ({ b }) => {
            loading = false

            let specification = server.loginData.spec.specification;
            const need_remap_symbol = !!(specification && specification.symbolsMap);

            // чтобы не менять математику из-за разного порядка символов, изменим их порядок на клиете
            // по мапе, приходящей от сервера
            // для этого нужно изменить в спецификации тадлицу выигрыше за комбинации и номера спец символов
            // а так же в стриме net заменять приходящие от сервера символы
            if (need_remap_symbol) {

                const symbolsMap = specification.symbolsMap;

                if (specification.priceList) {
                    let newList = specification.priceList.slice();
                    let specList = specification.priceList;
                    for (let i = 0; i < specList.length; ++i) {
                        newList[symbolsMap[i]] = specList[i];
                    }
                    specification.priceList = newList
                }

                if (specification.substitutableElements) {
                    for (let i = 0; i < specification.substitutableElements.length; ++i) {
                        let s = specification.substitutableElements[i];
                        specification.substitutableElements[i] = symbolsMap[s];
                    }
                }

                if (specification.symbolBonus !== undefined) {
                    let b = specification.symbolBonus;
                    specification.symbolBonus = symbolsMap[b];
                }
                if (specification.symbolScatter !== undefined) {
                    let s = specification.symbolScatter;
                    specification.symbolScatter = symbolsMap[s];
                }
                if (specification.symbolWild !== undefined) {
                    let w = specification.symbolWild;
                    specification.symbolWild = symbolsMap[w];
                }
            }

            console.log(specification);

            abstract_game( app, server.loginData.spec, b.settings )
            if ( b.reactive ) b.reactive( app, server.loginData.spec )

            if (need_remap_symbol) {
                const symbolsMap = specification.symbolsMap;
                const appSpace = app.space;

                const $changeSymbolNet = appSpace.s('net').alter();
                appSpace.s('net')
                    .map(net => {
                        if (net.state.state && net.state.state.stage && net.state.state.stage.math && net.state.state.stage.math.symbols) {
                            let symbols = net.state.state.stage.math.symbols;
                            for (let i = 0; i < symbols.length; ++i) {
                                let s = symbols[i];
                                symbols[i] = symbolsMap[s];
                            }
                        }
                        return net;
                    })
                    .to($changeSymbolNet)
            }
            
            connect( space, app )
            
            glue( space.s( 'card:attach' ), app.space.s( 'card' ) )
            space.s( 'card:terminal_id' ).map(id => formatTerminalId(id)).to(app.space.s( 'terminal_id' ));
            if (space.s( 'card:terminal_id' ).value) {
                app.space.s('terminal_id').next(formatTerminalId(space.s( 'card:terminal_id' ).value));
            }

            app.space.s( 'balance:money' )
                .with(app.space.s( 'balance' ), (money, balance) => {
                    return {
                        money: money,
                        minor_unit: balance.currency.minor_unit
                    }
                })
                .to(space.s('balance'));

            app.space.s('game_can_show').to(space.s('game_can_show'));
        } )
    
    //reset game on reconnect:
    let needReset
    space.s( 'running_game' )
        .filter( game_index => game_index >= 0 )
        .on( () => needReset = false )
    space.s( 'error_driver:isError' )
        .filter( ie => ie )
        .on( () => needReset = true )
    space.s( 'error_driver:isError' )
        .filter( ie => ! ie && needReset )
        .with( space.s( 'running_game' ), ( _, game_index ) => game_index )
        .to( space.s( 'run_game' ) )
    
    //load game resources if not loaded yet:
    space.s( 'sportbet:load_game' )
        .filter( b => ! b.loaded && ! b.loading && ! b.scheduled )
        .do( b => console.log( 'Loading', b, 'resources for current state ...' ) )
        .do( b => b.scheduled = true )
        .to( space.s( 'load:load' ) )
    
    space.s( 'load:complete' )
        .filter( ({ bundle }) => bundle && bundle.game && bundle.scheduled )
        .map( ({ bundle }) => bundle )
        .to( space.s( 'sportbet:load_game' ) )
    
    //quit:
    space.s( 'keyboard' )
        .filter( k => k === KEYS.MENU /*Esc*/ )
        .withLatestFrom(space.s('lobby_ui:isLobbyGames'), (k, is) => is)
        .filter(is => !is)
        .do( dispose )
        .map(() => false)
        .to(space.s('lobby_ui:isGamesRun'));
}





// WEBPACK FOOTER //
// ./src/main.es6